import { FC } from "react";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Menu, MenuDivider, MenuItem } from "mds/components/Menu";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { ArrowDownToLineIcon, ChevronDownIcon } from "mds/icons";

interface AssessmentSummaryReportMenuProps {
  disabled: boolean;
  onSummaryReport: () => void | Promise<void>;
  onDetailedReport: () => void | Promise<void>;
  onFullReport: () => void | Promise<void>;
}

export const AssessmentSummaryReportMenu: FC<AssessmentSummaryReportMenuProps> = ({
  disabled,
  onSummaryReport,
  onDetailedReport,
  onFullReport,
}) => {
  const MenuButton = (
    <SquareButton disabled={disabled} kind="tertiary" size="s">
      <IconText iconEnd={<ChevronDownIcon />} text={t("assessment_summary_report.menu.title")} />
    </SquareButton>
  );

  return (
    <Menu menuButton={MenuButton}>
      <MenuItem
        eventName="Assessment Summary Report - Export Summary"
        disableWhilePending
        onClick={onSummaryReport}
      >
        <div className="flex items-start gap-2">
          <ArrowDownToLineIcon className="mt-1" />

          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.summary_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.summary_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>

      <MenuDivider />

      <MenuItem
        eventName="Assessment Summary Report - Export Detailed"
        disableWhilePending
        onClick={onDetailedReport}
      >
        <div className="flex items-start gap-2">
          <ArrowDownToLineIcon className="mt-1" />
          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.detailed_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.detailed_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>

      <MenuDivider />

      <MenuItem
        eventName="Assessment Summary Report - Export Full"
        disableWhilePending
        onClick={onFullReport}
      >
        <div className="flex items-start gap-2">
          <ArrowDownToLineIcon className="mt-1" />
          <div className="flex flex-col">
            <div className="font-medium">
              {t("assessment_summary_report.menu.full_report.title")}
            </div>

            <div className="text-xs text-black-tint-40">
              {t("assessment_summary_report.menu.full_report.description")}
            </div>
          </div>
        </div>
      </MenuItem>
    </Menu>
  );
};
